import React, { useState } from "react";
import { asField } from "informed";
import { fetchUsers } from "../services/user_services";

const InputUserSearch = asField(
  ({
    error,
    required,
    helper,
    fieldState,
    fieldApi,
    field,
    label,
    col,
    autosaveFeedBack,
    nullOption,
    onChange,
    ...props
  }) => {
    const [typedValue, setTypedValue] = useState("");
    const [options, setOptions] = useState([]);
    const [showList, setShowList] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = async (e) => {
      const value = e.target.value;
      setTypedValue(value);

      fieldApi.setError(null);

      if (onChange) onChange(e);

      if (value.length < 2) {
        setOptions([]);
        setShowList(false);
        return;
      }

      setLoading(true);
      try {
        const data = await fetchUsers(value);

        let opts = data.results.map((u) => ({
          value: u.id,
          label: u.last_name || u.username,
        }));

        if (nullOption) {
          opts = [nullOption, ...opts];
        }

        setOptions(opts);
        setShowList(true);
      } finally {
        setLoading(false);
      }
    };

    const handleSelect = (opt) => {
      setTypedValue(opt.label);
      fieldApi.setValue(opt.value);
      setShowList(false);
    };

    return (
      <div className={`col-md-${col || 12} col-sm-12`} style={{ display: "flex" }}>
        <div className="input-type-style" style={{ display: "flex", width: "100%", position: "relative" }}>
          <input
            className={
              fieldState.error || error ? "input-error" : "input-style"
            }
            id={field}
            value={typedValue}
            onChange={handleChange}
            onFocus={() => options.length > 0 && setShowList(true)}
            autoComplete="off"
            {...props}
          />
          <label
            htmlFor={field}
            className={`input-label-style ${
              required ? "required" : ""
            } ${(fieldState.error || error) && "label-error"}`}
          >
            {label}
          </label>
          {helper && <label className="input-helper">{helper}</label>}
          {fieldState.error &&
            fieldState.error.map((e) => (
              <label key={e} className="input-helper text-danger">
                {e}
              </label>
            ))}

          {error && (
            <label className="input-helper text-danger">{error}</label>
          )}
          {showList && (
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                border: "1px solid #ccc",
                background: "white",
                position: "absolute",
                top: "100%",
                left: 0,
                zIndex: 999,
                width: "100%",
                maxHeight: "200px",
                overflowY: "auto",
                borderRadius: "0 0 4px 4px",
              }}
            >
              {loading && <li style={{ padding: 8 }}>Carregando...</li>}

              {options.map((opt) => (
                <li
                  key={opt.value}
                  style={{
                    padding: 8,
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                  }}
                  onClick={() => handleSelect(opt)}
                >
                  {opt.label}
                </li>
              ))}

              {!loading && options.length === 0 && (
                <li style={{ padding: 8 }}>Nenhum resultado</li>
              )}
            </ul>
          )}
        </div>
        <div style={{ display: "flex", marginTop: "40px" }}>
          {autosaveFeedBack}
        </div>
      </div>
    );
  }
);

export default InputUserSearch;
